import { ClothType, SunSailTextureType } from "@biz/definitions/SunSailDefinitions";
import { LanguageId } from "@biz/language/Languages";
import { LocaContext } from "@biz/language/LocaContext";

export interface IClothArticleId {
  system: string;
  group: string;
  type: string;
}

export interface IClothItemData {
  cloth: IClothData | undefined;
  colorId: string;
}

export interface IClothData extends IClothDataOptions {
  clothType: ClothType;
  articleId: IClothArticleId;
}

export interface IClothDataOptions {
  print?: boolean;
  glue?: boolean;
  // fire?: boolean;
  textureType?: SunSailTextureType;
}

export class ClothData {
  static from(clothType: ClothType, articleId: IClothArticleId, options?: IClothDataOptions): IClothData {
    return {
      clothType,
      articleId,
      ...options
    }
  }

  static getBaseArticleId(cloth: IClothData | undefined): string {
    if (!cloth)
      return "";
    if (!cloth.articleId)
      throw Error("No ArticleId for cloth: " + JSON.stringify(cloth));
    return cloth.articleId.system + cloth.articleId.group + cloth.articleId.type;
  }

  static getClothNameId(clothType: ClothType): LanguageId {
    return LocaContext.connect("Cloth", ClothType[clothType])
  }

  static equals(a: IClothData, b: IClothData): boolean {
    return ClothData.getBaseArticleId(a) === ClothData.getBaseArticleId(b)
    // return a.clothType === b.clothType && !!a.print === !!b.print && !!a.glue === !!b.glue && a.textureType === b.textureType;
  }

  static calcKey(item: IClothData | undefined): string {
    if (!item)
      return "";
    // return "" + item.clothType + "_" + !!item.print + "_" + !!item.glue + "_" + false /*item.style*/;
    return ClothData.getBaseArticleId(item)
  }

  static isAustronet(clothType: ClothType | undefined): boolean {
    if (!clothType)
      return false;
    return [ClothType.Austronet932, ClothType.Austronet940, ClothType.Austronet950, ClothType.Austronet960].includes(clothType);
  }
}
